import React, {useState, useEffect, useContext} from 'react'
import '../App.scss'
import Map from './Map'
import axios from 'axios'
import ReactModal from "react-modal";
import {UserContext} from "./UserContext";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {accessToken} from "./tokens";
import {nationalParks} from "./utils/NationalParksUtils";
import nflTeams from "./utils/nflTeams";
import {convertCamelCaseToSpacedWords, countryList, getBearerToken, getServerUrl, usStates} from "./utils/utils";
import Tooltip from "@mui/material/Tooltip";
import {Box, FormControl, MenuItem, Select} from "@mui/material";
import mlbTeams from "./utils/mlbTeams";

function CreateTrip({open, onClose, locations, selectedCountry, selectedState, selectedCategory, selectedCategoryItem, selectedLocation}) {
    const {user} = useContext(UserContext)
    const [name, setName] = useState('');
    const [location, setLocation] = useState(selectedLocation || '')
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [tripType, setTripType] = useState("single");
    const [parentTripName, setParentTripName] = useState('')
    const [parentTrips, setParentTrips] = useState([])
    const [category, setCategory] = useState(selectedCategory || "")
    const [categoryItem, setCategoryItem] = useState(selectedCategoryItem || "")
    const [categoryItemDetail1, setCategoryItemDetail1] = useState("")
    const [categoryItemDetail2, setCategoryItemDetail2] = useState("")
    const [categoryItemDetail3, setCategoryItemDetail3] = useState("")
    const [locationSearchResults, setLocationSearchResults] = useState([])
    const [country, setCountry] = useState(selectedCountry || 'United States')
    const [state, setState] = useState(selectedState || '')
    const [customCategory, setCustomCategory] = useState('')
    const [userCategories, setUserCategories] = useState([])


    const searchForLocation = (selectedLocation) => {
        fetch(`https://api.mapbox.com/search/searchbox/v1/suggest?q=${selectedLocation}&language=en&limit=5&access_token=${accessToken}&session_token=${user.id}`)
            .then(response => response.json())
            .then(data => {
                setLocationSearchResults(data.suggestions)
            })
    }

    const fetchParentTrips = async () => {
        axios.get(`${getServerUrl()}/parentTrips`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setParentTrips(response.data)
            })
    }

    const fetchUserCategories = async () => {
        axios.get(`${getServerUrl()}/categories`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setUserCategories(response.data)
            })
    }

    useEffect(() => {
        if (open) {
            fetchParentTrips()
            fetchUserCategories()
        }
    }, [open])

    useEffect(() => {
        const searchLocations = setTimeout(() => {
            if (location) {
                searchForLocation(location)
            }
        }, 300)
        return () => clearTimeout(searchLocations)
    }, [location])

    const clearModal = () => {
        setName('');
        setLocation('')
        setStartDate('');
        setEndDate('');
        setTripType('single');
        setParentTripName('')
        setParentTrips([])
        setCategory("")
        setCategoryItemDetail1(null)
        setCategoryItemDetail2(null)
        setCategoryItemDetail3(null)
        setState('')
        setCountry('United States')
        setCustomCategory('')
    }


    const submitTrip = async () => {
        axios.post(`${getServerUrl()}/trip/create`, {
            name: name,
            location: location,
            startDate: startDate,
            endDate: endDate,
            category: category,
            categoryItem: categoryItem,
            categoryItemDetail1: categoryItemDetail1,
            categoryItemDetail2: categoryItemDetail2,
            categoryItemDetail3: categoryItemDetail3,
            parentTrip: parentTripName,
            country,
            state,
            tripType,
            customCategory: customCategory
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            }
        }).then(response => {
            clearModal()
            onClose(response.data)
        });
    }

    const displayParentTripOptions = parentTrips.map(tripName => {
        return <option value={tripName}>{tripName}</option>
    })


    // const updateRequiredFieldsCss = mouseEnter => {
    //     const requiredFields = document.getElementsByClassName("required")
    //     requiredFields.forEach(element => {
    //         if (mouseEnter) {
    //             element.style.color = 'red'
    //         } else {
    //             element.style.color = 'black'
    //         }
    //     })
    // }

    const createTripDisabled = !name || !location || !country || (country === 'United States' && !state) || !startDate || !endDate

    const nflTeamsList = ["", ...Object.keys(nflTeams).sort()]

    const categoryList = ["", ...userCategories.map(category => category.name), "National Park", "NFL", "MLB", "Custom"]

    return (
        <ReactModal isOpen={open} className="view-trip-modal">
            <div className="createTrip">
                <button id="go-home-button" onClick={() => {
                    clearModal()
                    onClose()
                }}>
                    Close
                </button>

                <div id="create-trip-info" style={{width: "100%"}}>
                    <div style={{width: "calc(100% - 30px)"}}>
                        <Map location={location}/>
                    </div>
                    <div id="tripInfo">
                        <div className="tripTypeDiv">
                            <div className="parent-trip-input">
                                <p className="required">Trip Name</p>
                                <Autocomplete
                                    id="free-solo-demo"
                                    freeSolo
                                    filterOptions={(x) => x}
                                    options={[]}
                                    renderInput={(params) => <TextField {...params}
                                                                        label="Enter trip's name"/>}
                                    onInputChange={(event, newInputValue) => {
                                        setName(newInputValue)
                                    }}
                                    inputValue={name}
                                />
                            </div>
                        </div>
                        <br/>
                        <div className="tripTypeDiv">
                            <div className="parent-trip-input">
                                <p className="required">Location</p>
                                <Autocomplete
                                    id="free-solo-demo"
                                    freeSolo
                                    filterOptions={(x) => x}
                                    options={locationSearchResults?.map(locationSearchResult => `${locationSearchResult.name} - ${locationSearchResult.place_formatted}`)}
                                    renderInput={(params) => <TextField {...params}
                                                                        label="Enter trip's main location"/>}
                                    onInputChange={(event, newInputValue) => {
                                        setLocation(newInputValue)
                                        locationSearchResults?.forEach(locationSearchResult => {
                                            if (newInputValue.includes(" - ") && locationSearchResult.place_formatted === newInputValue.split(" - ")[1]) {
                                                setCountry(locationSearchResult?.context?.country?.name || "United States")
                                                setState(locationSearchResult?.context?.region?.name || "")
                                            }
                                        })
                                    }}
                                    inputValue={location}
                                />
                            </div>
                        </div>
                        <div className="tripTypeDiv">
                            <div className="parent-trip-input">
                                <p className="required">Country</p>
                                <Autocomplete
                                    id="free-solo-demo"
                                    freeSolo
                                    filterOptions={(x) => x}
                                    options={countryList}
                                    renderInput={(params) => <TextField {...params}
                                                                        label="Enter country visited"/>}
                                    onInputChange={(event, newInputValue) => {
                                        setCountry(newInputValue)
                                    }}
                                    inputValue={country}
                                    style={{width: 200}}
                                />
                            </div>
                        </div>
                        <div className="tripTypeDiv">
                            <div className="parent-trip-input">
                                <p className="required">State</p>
                                <Autocomplete
                                    id="free-solo-demo"
                                    freeSolo
                                    filterOptions={(x) => x}
                                    options={usStates}
                                    renderInput={(params) => <TextField {...params}
                                                                        label="Enter state visited"/>}
                                    onInputChange={(event, newInputValue) => {
                                        setState(newInputValue)
                                    }}
                                    inputValue={state}
                                    style={{width: 200}}
                                />
                            </div>
                        </div>
                        <br/>
                        <label htmlFor="startDate">
                            <span className="required">Start Date </span>
                            <input className="trip-date-input" id="startDate" value={startDate}
                                   onChange={e => {
                                       setStartDate(e.target.value)
                                       setEndDate(e.target.value)
                                   }}
                                   type="date"/>
                        </label>
                        <br/>
                        <label htmlFor="endDate">
                            <span className="required">End Date </span>
                            <input className="trip-date-input" id="endDate" value={endDate}
                                   onChange={e => setEndDate(e.target.value)} type="date"/>
                        </label>
                       <div className="category-div-container">
                        <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                            <span>Category</span>
                            <FormControl size="small" sx={{minWidth: 200}}>
                                <Select
                                    value={category}
                                    onChange={e => setCategory(e.target.value)}
                                    displayEmpty
                                    inputProps={{'aria-label': 'Category'}}
                                    style={{background: "white"}}
                                >
                                    {categoryList.map(categoryItem => (
                                        <MenuItem value={categoryItem} disabled={categoryItem === ""} key="categoryItem">
                                            {categoryItem === "" ? "Select a trip category" : categoryItem}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        {category === 'Custom' && (
                            <div className="tripTypeDiv">
                                <div className="parent-trip-input">
                                    <p>Category Name</p>
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        filterOptions={(x) => x}
                                        options={[]}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Enter custom category"/>}
                                        onInputChange={(event, newInputValue) => {
                                            setCustomCategory(newInputValue)
                                        }}
                                        inputValue={customCategory}
                                        style={{width: 200}}
                                    />
                                </div>
                            </div>
                        )}
                        {category === "National Park" && (
                            <label htlmFor="categoryItem">
                                National Park Visited
                                <select className="trip-select-dropdown" id="categoryItem" value={categoryItem}
                                        onChange={e => setCategoryItem(e.target.value)}>
                                    {nationalParks.map(nationalPark => {
                                        return <option>{nationalPark.name}</option>
                                    })}
                                </select>
                            </label>
                        )}
                        {category === "NFL" && (
                            <label htlmFor="categoryItem">
                                Home Team
                                <select className="trip-select-dropdown" id="categoryItem" value={categoryItem}
                                        onChange={e => setCategoryItem(e.target.value)}>
                                    {nflTeamsList.map(team => {
                                        return <option>{team}</option>
                                    })}
                                </select>
                            </label>
                        )}
                        {category === "NFL" && (
                            <label htlmFor="categoryItemDetail1">
                                Away Team
                                <select className="trip-select-dropdown" id="categoryItemDetail1"
                                        value={categoryItemDetail1}
                                        onChange={e => setCategoryItemDetail1(e.target.value)}>
                                    {nflTeamsList.map(team => {
                                        return <option>{team}</option>
                                    })}
                                </select>
                            </label>
                        )}
                        {category === "NFL" && (
                            <label htlmFor="categoryItemDetail2">
                                Home Team Score
                                <input className="trip-date-input" id="categoryItemDetail2" value={categoryItemDetail2}
                                       onChange={e => setCategoryItemDetail2(e.target.value)}/>
                            </label>
                        )}
                        {category === "NFL" && (
                            <label htlmFor="categoryItemDetail3">
                                Away Team Score
                                <input className="trip-date-input" id="categoryItemDetail3" value={categoryItemDetail3}
                                       onChange={e => setCategoryItemDetail3(e.target.value)}/>

                            </label>
                        )}
                           {category === "MLB" && (
                               <label htlmFor="categoryItem">
                                   Team Visited
                                   <select className="trip-select-dropdown" id="categoryItem" value={categoryItem}
                                           onChange={e => setCategoryItem(e.target.value)}>
                                       {["", ...Object.keys(mlbTeams).sort()].map(team => {
                                           return <option value={convertCamelCaseToSpacedWords(team)}>{team === "" ? "Select a Team" : convertCamelCaseToSpacedWords(team)}</option>
                                       })}
                                   </select>
                               </label>
                           )}
                           {category === "MLB" && (
                               <label htlmFor="categoryItemDetail1">
                                   Away Team
                                   <select className="trip-select-dropdown" id="categoryItemDetail1"
                                           value={categoryItemDetail1}
                                           onChange={e => setCategoryItemDetail1(e.target.value)}>
                                       {["", ...Object.keys(mlbTeams).sort()].map(team => {
                                           return <option value={convertCamelCaseToSpacedWords(team)}>{team === "" ? "Select a Team" : convertCamelCaseToSpacedWords(team)}</option>
                                       })}
                                   </select>
                               </label>
                           )}
                           {category === "MLB" && (
                               <label htlmFor="categoryItemDetail2">
                                   Home Team Score
                                   <input className="trip-date-input" id="categoryItemDetail2"
                                          value={categoryItemDetail2}
                                          onChange={e => setCategoryItemDetail2(e.target.value)}/>
                               </label>
                           )}
                           {category === "MLB" && (
                               <label htlmFor="categoryItemDetail3">
                                   Away Team Score
                                   <input className="trip-date-input" id="categoryItemDetail3"
                                          value={categoryItemDetail3}
                                          onChange={e => setCategoryItemDetail3(e.target.value)}/>

                               </label>
                           )}
                       </div>
                        <div className="tripTypeDiv">
                            <label htlmFor="parentTripCheckbox">
                                Trip type
                                <select className="trip-select-dropdown" id="parentTripSelect" value={tripType}
                                        onChange={e => setTripType(e.target.value)}>
                                    <option value="single">Single Location Trip</option>
                                    <option value="multiple">Multiple Location Trip</option>
                                </select>
                            </label>
                            {/*{tripType === 'parentTrip' && (<label htmlFor="parentTripInput">*/}
                            {/*    Parent Trip Name*/}
                            {/*    <input id='parentTripInput' value={parentTripName}*/}
                            {/*           onChange={e => setParentTripName(e.target.value)}/>*/}
                            {/*</label>)}*/}
                            {tripType === 'multiple' && (
                                <div className="parent-trip-input">
                                    Parent Trip Name
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        options={parentTrips?.filter(trip => !!trip)}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Type parent trip name, or choose from existing..."/>}
                                        onInputChange={(event, newInputValue) => {
                                            setParentTripName(newInputValue)
                                        }}
                                        inputValue={parentTripName}
                                    />
                                </div>
                            )}
                        </div>
                        <br/>

                    </div>
                    {createTripDisabled && (
                        <Tooltip title="You must fill out required fields to create trip">
                            <button onClick={submitTrip} style={{width: 200, opacity: 0.75}}
                                    disabled={createTripDisabled}>
                                Create trip!
                            </button>
                        </Tooltip>
                    )}
                    {!createTripDisabled && (
                        <button onClick={submitTrip} style={{width: 200}}
                        >
                            Create trip!
                        </button>
                    )}
                </div>

            </div>
        </ReactModal>
    );
}

export default CreateTrip;
